// Easify's theme-integration extension point. The app owns validation and add-on pricing.
(() => {
  const prior = window.TPOCustomFunctions || {};
  const previousAfter = prior.cart?.afterAddToCart;
  const bindings = new WeakMap();
  window.TPOCustomFunctions = {
    ...prior,
    productPageOptions: {
      ...prior.productPageOptions,
      getProductFormContainer() { return document.querySelector('fp-size-quantity .fp-shop-pay-form'); },
      getAddToCartButton() { return document.querySelector('[data-sk-easify-submit]'); },
      getVariantChangeContainer(form) { return form?.querySelector('input[name=id]') || null; },
      initAddToCartFunction(bind, form) {
        const button = document.querySelector('[data-sk-easify-submit]');
        if (button && form) { bindings.get(button)?.(); bindings.set(button, bind(button, form)); button.dataset.appReady = 'true'; }
      }
    },
    cart: {
      ...prior.cart,
      afterAddToCart(button, action = 'cart') {
        button.disabled = false;
        const mobileProductAdd = action !== 'checkout' && matchMedia('(max-width: 749px)').matches && document.querySelector('[data-sk-pdp]');
        if (button.matches('[data-sk-easify-submit]') || mobileProductAdd) {
          document.dispatchEvent(new CustomEvent('sk:pdp-app-added', { detail: { action } }));
          return;
        }
        if (previousAfter) return previousAfter(button, action);
        // Keep the app's native destination semantics for its other buttons.
        if (action === 'checkout') location.assign((window.Shopify?.routes?.root || '/') + 'checkout');
        else location.assign((window.Shopify?.routes?.root || '/') + 'cart');
      }
    }
  };
})();
